<div
  *ngIf="domOpen"
  #overlayRoot
  class="v2-request-phys-col"
  [class.v2-request-phys-col--closing]="isClosing"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="'REQUEST_PHYSICAL' | translate"
>
  <div
    class="v2-rpc-overlay-request-loader"
    [ngStyle]="{
      opacity: overlayRequestsLoading ? '1' : '0',
      'pointer-events': overlayRequestsLoading ? 'auto' : 'none'
    }"
  >
    <div #rpcOverlayLoader class="loader"></div>
  </div>

  <button
    type="button"
    class="v2-rpc-floating-close"
    (click)="onHeaderBack()"
    [class.v2-rpc-floating-in]="headerReveal"
    [attr.aria-label]="'BUTTON_CLOSE' | translate"
  >
    ×
  </button>

  <div
    class="v2-rpc-title-pill"
    [class.v2-rpc-floating-in]="headerReveal"
    aria-hidden="true"
  >
    {{ 'REQUEST_PHYSICAL' | translate }}
  </div>

  <div
    class="v2-rpc-body"
    [class.v2-rpc-body--requests-loading]="overlayRequestsLoading"
    [attr.aria-busy]="overlayRequestsLoading"
  >
    <div class="v2-rpc-scroll-outer v2-request-phys-col-scroll">
      <div
        class="manage-wrapper v2-req-phys-wrap"
        [class.opened]="contentReveal"
        [class.loaded]="contentReveal && !overlayRequestsLoading"
      >
        <main class="v2-rpc-scroll">
  <div *ngIf="currentStatus==='NOT_AVAILABLE'">
    <!--ion-item class="ion-text-wrap ion-text-center"
      *ngIf="physCollectionIconPath === undefined || physCollectionIconPath === '' || physCollectionIconPath === 'empty'">
      <div class="col-div"><img class="col-icon" src="assets/images/logo-letter.svg"></div>
    </div>
    <div class="v2-rpc-item ion-text-wrap ion-text-center"
      *ngIf="physCollectionIconPath !== undefined && physCollectionIconPath !== ''  && physCollectionIconPath !== 'empty'">
      <div class="col-div"><img class="col-icon" src="{{physCollectionIconPath}}"></div>
    </div>


    <div class="v2-rpc-item">
      <div class="v2-rpc-lbl">
        <h2 class="ion-text-wrap ion-text-center">{{'REQUEST_PHYSICAL_PHYS_COL_NOT_AVAILABLE_HEADER' | translate}}</h2>
        <br>
        <p class="ion-text-wrap ion-text-center">{{'REQUEST_PHYSICAL_PHYS_COL_NOT_AVAILABLE_TEXT_1' | translate}}</p> <br>
        <p class="ion-text-wrap ion-text-center">{{'REQUEST_PHYSICAL_PHYS_COL_NOT_AVAILABLE_TEXT_2' | translate}}</p> <br>
        <p class="ion-text-wrap ion-text-center">{{'REQUEST_PHYSICAL_PHYS_COL_NOT_AVAILABLE_TEXT_3' | translate}}</p>
      </div>
    </ion-item-->

    <div class="loader-parent" style="z-index: 99">
      <div #lottieNotAvailable class="loader"></div>
      <h1
        class="loader-text-Not-Available"
        [class.loader-text-running]="loaderTextCssActive"
        (animationstart)="onLoaderTextAnimationStart($event)"
        (animationiteration)="onLoaderTextCycle($event)"
      >
        {{ animTexArr10[animTextNumber]|translate }}
      </h1>
    </div>

    <div class="v2-rpc-item">
      <div class="v2-rpc-row">
        <div class="v2-rpc-col">
          <app-btn class="v2-rpc-action-btn" type="danger" [text]="'ADD_ENTRY_CANCEL' | translate" (clicked)="cancelRequest()"></app-btn>

        </div>
      </div>
    </div>
  </div>

  <!-- ###############  PHYSICAL COLLECTION ON HOLD   ,WAITING FOR FIX OR CONTENT  ############  -->

  <div *ngIf="currentStatus==='WAIT'">
    <!--ion-item class="ion-text-wrap ion-text-center" *ngIf="physCollectionIconPath === 'empty'">
      <div class="col-div"><span class="v2-rpc-inline-spinner" aria-hidden="true"></span></div>
    </div>


    <div class="v2-rpc-item ion-text-wrap ion-text-center"
      *ngIf="physCollectionIconPath !== undefined && physCollectionIconPath !== '' && physCollectionIconPath !== 'empty'">
      <div class="col-div"><img class="col-icon" src="{{physCollectionIconPath}}"></div>
    </div>
    <div class="v2-rpc-item ion-text-wrap ion-text-center"
      *ngIf="physCollectionIconPath === undefined || physCollectionIconPath === ''">
      <div class="col-div"><img class="col-icon" src="assets/images/logo-letter.svg"></div>
    </div>


    <div class="v2-rpc-item">
      <div class="v2-rpc-lbl">
        <h2 class="ion-text-wrap ion-text-center">{{'PHYS_PLEASE_WAIT' | translate}}</h2><br>
        <p class="ion-text-wrap ion-text-center">{{'PHYS_PLEASE_WAIT_TEXT_1' | translate}}</p> <br>
      </div>
    </ion-item-->

    <div class="loader-parent" style="z-index: 99">
      <div #lottieWait class="loader"></div>
      <h1
        class="loader-text-Wait"
        [class.loader-text-running]="loaderTextCssActive"
        (animationstart)="onLoaderTextAnimationStart($event)"
        (animationiteration)="onLoaderTextCycle($event)"
      >
        {{ animTexArr6[animTextNumber]|translate }}
      </h1>
    </div>

    <div class="v2-rpc-item">
      <div class="v2-rpc-row">
        <div class="v2-rpc-col">
          <app-btn class="v2-rpc-action-btn" type="danger" [text]="'ADD_ENTRY_CANCEL' | translate" (clicked)="cancelRequest()"></app-btn>

        </div>
      </div>
    </div>
  </div>

  <div *ngIf="currentStatus==='AVAILABLE'">
    <!--ion-item class="ion-text-wrap ion-text-center"
      *ngIf="physCollectionIconPath === undefined || physCollectionIconPath === ''">
      <div class="col-div"><img class="col-icon" src="assets/images/logo-letter.svg"></div>
    </div>
    <div class="v2-rpc-item ion-text-wrap ion-text-center"
      *ngIf="physCollectionIconPath !== undefined && physCollectionIconPath !== '' && physCollectionIconPath !== 'empty'">
      <div class="col-div"><img class="col-icon" src="{{physCollectionIconPath}}"></div>
    </div>

    <div class="v2-rpc-item">
      <div class="v2-rpc-lbl">
        <h2 class="ion-text-wrap ion-text-center">{{'REQUEST_PHYSICAL_COL_HEADER' | translate}}</h2><br>
        <p class="ion-text-wrap ion-text-center">{{'REQUEST_PHYSICAL_COL_TEXT_1' | translate}}</p> <br>
        <p class="ion-text-wrap ion-text-center">{{'REQUEST_PHYSICAL_COL_TEXT_2' | translate}}</p> <br>
        <p class="ion-text-wrap ion-text-center">{{'REQUEST_PHYSICAL_COL_TEXT_3' | translate}}</p>
      </div>
    </div>

    <div class="v2-rpc-item">
      <div class="v2-rpc-lbl">
        <h2 class="ion-text-wrap ion-text-center">{{'REQUEST_INSERT_YOUR_DATA' | translate}}</h2><br>
      </div>
    </ion-item-->

    <div *ngIf="!rpcUserCollectionComplete && !overlayRequestsLoading" class="v2-rpc-incomplete-gate">
      <div class="v2-rpc-item ion-text-wrap ion-text-center v2-rpc-incomplete-gate__message">
        <div class="v2-rpc-lbl">
          <h2 class="ion-text-wrap ion-text-center v2-rpc-incomplete-gate__title">
            {{ 'REQUEST_PHYSICAL_COLLECTION_INCOMPLETE_TITLE' | translate }}
          </h2>
          <p class="ion-text-wrap ion-text-center v2-rpc-incomplete-gate__body">
            {{ 'REQUEST_PHYSICAL_COLLECTION_INCOMPLETE_BODY' | translate }}
          </p>
        </div>
      </div>

      <div class="v2-rpc-section-divider v2-rpc-incomplete-gate__divider">
        <div class="v2-rpc-lbl">{{ 'REQUEST_PHYSICAL_COLLECTION_INCOMPLETE_SECTION_NEXT' | translate }}</div>
      </div>

      <app-btn
        class="v2-rpc-action-btn"
        type="primary"
        [text]="'REQUEST_PHYSICAL_COLLECTION_GET_BINDERS_CTA' | translate"
        (clicked)="openGetBindersOverlay()"
      ></app-btn>

      <div class="v2-rpc-incomplete-gate__footer">
        <app-btn
          class="v2-rpc-action-btn v2-rpc-incomplete-gate__dismiss-btn"
          type="danger"
          [text]="'ADD_ENTRY_CANCEL' | translate"
          (clicked)="cancelRequest()"
        ></app-btn>
      </div>
    </div>

    <div *ngIf="rpcUserCollectionComplete && !overlayRequestsLoading">
    <div class="loader-parent" style="z-index: 99">
      <div #lottieAvailable class="loader"></div>
      <h1
        class="loader-text-available"
        [class.loader-text-running]="loaderTextCssActive"
        (animationstart)="onLoaderTextAnimationStart($event)"
        (animationiteration)="onLoaderTextCycle($event)"
      >
        {{ animTexArr[animTextNumber]|translate }}
      </h1>
    </div>

    <div class="add-scrolling">
      <div class="v2-rpc-section-divider">
        <div class="v2-rpc-lbl"
          style="
            font-size: large;
            font-weight: bold;
            color: var(--ion-color-primary);
          "
          >{{'SHIPPING_TYPES'| translate}}</div>
      </div>

      <div class="v2-rpc-item">
        <div
          class="v2-rpc-radio-group"
          role="radiogroup"
          [attr.aria-label]="'SHIPPING_TYPES' | translate"
        >
          <label class="v2-rpc-radio-row">
            <input
              type="radio"
              name="rpc-ship-mode"
              value="SHIPPING"
              [(ngModel)]="shippingMethod"
              (ngModelChange)="shippingMethodChange()"
            />
            <span class="v2-rpc-radio-row__body">
              <span class="v2-rpc-radio-row__title">{{'MAIL_OPTION'| translate}}</span>
              <span class="v2-rpc-radio-row__sub">{{'ADD_SHIPPING_COSTS'| translate}}</span>
            </span>
          </label>
          <label class="v2-rpc-radio-row">
            <input
              type="radio"
              name="rpc-ship-mode"
              value="PICKUP"
              [(ngModel)]="shippingMethod"
              (ngModelChange)="shippingMethodChange()"
            />
            <span class="v2-rpc-radio-row__text">{{'PICKUP_OPTION'| translate}}</span>
          </label>
        </div>
      </div>

      <!-- ###############  PICKUP METHOD SELECTED   ############  -->
      <div *ngIf="shippingMethod==='PICKUP'">
        <div class="v2-rpc-section-divider top-20">
          <div class="v2-rpc-lbl" style="font-size: large; font-weight: bold"
            >{{'PICKUP_SPOTS'| translate}}</div>
        </div>

        <div class="v2-rpc-item" *ngIf="shippingMethodsList.length === 0">
          <p class="v2-rpc-note"> {{'NO_PICKUP_SPOTS'| translate}} </p>
        </div>

        <div class="v2-rpc-item" *ngIf="shippingMethodsList.length !== 0">
          <div class="v2-rpc-radio-group" role="radiogroup">
            <label
              class="v2-rpc-radio-row"
              *ngFor="let item of shippingMethodsList"
            >
              <input
                type="radio"
                name="rpc-pickup-point"
                [value]="item.shipping_method_config_id"
                [(ngModel)]="selectedMethodConfigId"
                (ngModelChange)="onPickupMethodConfigChange($event)"
              />
              <span class="v2-rpc-radio-row__text"
                >{{item.name}}
                <p>{{item.description}}</p></span
              >
            </label>
          </div>
        </div>

        <div class="v2-rpc-section-divider" style="font-size: large; font-weight: bold">
          <div class="v2-rpc-lbl">{{'ORDER_DETAILS'|translate}}</div>
        </div>
        <div class="v2-rpc-item item-expand">
          <div class="item-inner item-inner--order-qty-row">
            <div class="item-input-wrapper v2-rpc-order-col v2-rpc-order-col--qty v2-rpc-qty-stepper-field">
              <div class="v2-rpc-field-label" id="rpc-album-qty-pickup-label">{{ 'QUANTITY' | translate }}</div>
              <div
                class="v2-rpc-qty-stepper"
                role="group"
                [attr.aria-labelledby]="'rpc-album-qty-pickup-label'"
              >
                <button
                  type="button"
                  class="v2-rpc-qty-stepper__btn"
                  (click)="decrementAlbumQty()"
                  [disabled]="isAlbumQtyDecrementDisabled()"
                  [attr.aria-label]="'DECREASE_QUANTITY' | translate"
                >
                  −
                </button>
                <div class="v2-rpc-qty-stepper__value" aria-live="polite" aria-atomic="true">
                  {{ requestFormNumberOfUnits }}
                </div>
                <button
                  type="button"
                  class="v2-rpc-qty-stepper__btn"
                  (click)="incrementAlbumQty()"
                  [disabled]="isAlbumQtyIncrementDisabled()"
                  [attr.aria-label]="'INCREASE_QUANTITY' | translate"
                >
                  +
                </button>
              </div>
            </div>
            <div class="v2-rpc-order-col v2-rpc-order-col--unit-price v2-rpc-lbl" style="color: var(--ion-color-text)">
              <p>
                {{'VALUE' | translate}} {{phyColVCents/100 |
                currency:"EUR":"symbol"}} {{"VALUE_PER_ALBUM" | translate}}
              </p>
            </div>
          </div>
        </div>

        <div class="v2-rpc-section-divider" style="font-size: large; font-weight: bold">
          <div class="v2-rpc-lbl">{{'PHY_COL_VALUES'|translate}}</div>
        </div>
        <div class="v2-rpc-item v2-rpc-summary">
          <div class="v2-rpc-summary-total v2-rpc-summary-total--only">
            <span class="v2-rpc-summary-total__label"
              >{{'PHY_COL_COLLECTION_TOTAL'|translate}}</span
            >
            <span class="v2-rpc-summary-total__value">{{
              getTotalPrice() | currency : 'EUR' : 'symbol'
            }}</span>
          </div>
        </div>

        <div class="v2-rpc-section-divider" *ngIf ="getTotalPrice()> 0 " style="font-size: large; font-weight: bold">
          <div class="v2-rpc-lbl">{{'FIN_METHODS'|translate}}</div>
        </div>

        <div class="v2-rpc-item" *ngIf ="getTotalPrice()> 0 ">
          <div class="v2-rpc-row">
            <div class="v2-rpc-col">
              <div (click)="setFinMethod('MBWAY')">
                <img
                  class="title-image"
                  [ngClass]="{'dimmed' : requestFormFinMethod!=='MBWAY'}"
                  src="/assets/images/mbway_logo.svg"
                  width="100%"
                  height="100%"
                />
              </div>
            </div>
            <div class="v2-rpc-col">
              <div (click)="setFinMethod('VISA')">
                <img
                  class="title-image"
                  [ngClass]="{'dimmed' : requestFormFinMethod!=='VISA'}"
                  src="/assets/images/visa.svg"
                  width="100%"
                  height="100%"
                />
              </div>
            </div>
            <div class="v2-rpc-col">
              <div (click)="setFinMethod('VISA')">
                <img
                  class="title-image"
                  [ngClass]="{'dimmed' : requestFormFinMethod!=='VISA'}"
                  src="/assets/images/mastercard.svg"
                  width="100%"
                  height="100%"
                />
              </div>
            </div>
            <div class="v2-rpc-col">
              <div (click)="setFinMethod('VISA')">
                <img
                  class="title-image"
                  [ngClass]="{'dimmed' : requestFormFinMethod!=='VISA'}"
                  src="/assets/images/maestro.svg"
                  width="100%"
                  height="100%"
                />
              </div>
            </div>
          </div>
        </div>

        <div
          class="v2-rpc-item v2-rpc-mbway-block"
          *ngIf="getTotalPrice()> 0 && requestFormFinMethod==='MBWAY'"
        >
          <div class="v2-rpc-mbway-grid">
            <label class="v2-rpc-field-label v2-rpc-mbway-grid__label" for="rpc-mbway-pickup">{{
              'GET_BINDERS_MBWAY_NUMBER' | translate
            }}</label>
            <input
              id="rpc-mbway-pickup"
              #phoneInput
              class="v2-rpc-native-input v2-rpc-mbway-grid__input"
              inputmode="tel"
              type="tel"
              maxlength="9"
              [placeholder]="'REQUEST_PHONE_MBWAY_PLACEHOLDER' | translate"
              [attr.aria-invalid]="!validatePhonePT(requestFormMsisdn)"
              [(ngModel)]="requestFormMsisdn"
              (input)="appendCountryCode($event)"
            />
            <label class="v2-rpc-check-row v2-rpc-mbway-grid__save">
              <input type="checkbox" [(ngModel)]="requestFormStoreMsisdn" />
              <span>{{'GET_BINDERS_MBWAY_NUMBER_STORE' | translate}}</span>
            </label>
            <p
              class="v2-rpc-note error-message v2-rpc-mbway-grid__error"
              *ngIf="!validatePhonePT(requestFormMsisdn)"
              role="alert"
            >
              {{ 'INVALID_PT_PHONE' | translate }}
            </p>
          </div>
        </div>
        <div class="v2-rpc-item" *ngIf="getTotalPrice()> 0 && requestFormFinMethod==='VISA'">
          <div class="v2-rpc-row">
            <div class="v2-rpc-col v2-rpc-col--span-12">
              <p></p>
              <p style="text-align: center; font-size: small">
                {{'TRANSLATE_VISA_FIN_EXPLAIN' | translate}}
              </p>
              <p></p>
            </div>
          </div>
        </div>

        <div class="v2-rpc-item" *ngIf="getTotalPrice()>0">
          <label class="v2-rpc-check-row">
            <input type="checkbox" [(ngModel)]="requestForminvoiceRequired" />
            <span>{{'GET_BINDERS_REQUIRE_INVOICE' | translate}}</span>
          </label>
        </div>

        <div class="v2-rpc-item" *ngIf="getTotalPrice()>0 && requestForminvoiceRequired">
          <div class="v2-rpc-row">
            <div class="v2-rpc-col">
              <div class="v2-rpc-item">
                <input
                  class="v2-rpc-native-input"
                  inputmode="numeric"
                  type="text"
                  [(ngModel)]="requestFormNifForInvoice"
                  [placeholder]="'GET_BINDERS_PUT_NIF' | translate"
                  (ngModelChange)="onNifChange()"
                />
              </div>
              <p class="v2-rpc-note" *ngIf="!validNif" class="error-message"
                >{{"INVALID_NIF"| translate}}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- ###############  SHIPPING METHOD SELECTED   ############  -->
      <div *ngIf="shippingMethod==='SHIPPING'">
        <div
          class="v2-rpc-section-divider top-20"
          style="font-size: large; font-weight: bold"
        >
          <div class="v2-rpc-lbl" style="font-size: large; font-weight: bold"
            >{{ 'SHIPPING_DATA' | translate }}</div>
        </div>

        <div class="v2-rpc-item v2-rpc-field">
          <label class="v2-rpc-field-label" for="rpc-ship-name">{{
            'REQUEST_NAME_PLACEHOLDER_LABLE' | translate
          }}</label>
          <input
            id="rpc-ship-name"
            class="v2-rpc-native-input"
            type="text"
            [placeholder]="'REQUEST_NAME_PLACEHOLDER' | translate"
            [(ngModel)]="requestFormName"
          />
        </div>

        <div class="v2-rpc-item v2-rpc-field">
          <label class="v2-rpc-field-label" for="rpc-ship-addr1">{{
            'REQUEST_ADDRESS_1_PLACEHOLDER_LABLE' | translate
          }}</label>
          <input
            id="rpc-ship-addr1"
            class="v2-rpc-native-input"
            type="text"
            [placeholder]="'REQUEST_ADDRESS_1_PLACEHOLDER' | translate"
            [(ngModel)]="requestFormAddress1"
          />
        </div>

        <div class="v2-rpc-item v2-rpc-field">
          <label class="v2-rpc-field-label" for="rpc-ship-addr2">{{
            'REQUEST_ADDRESS_2_PLACEHOLDER' | translate
          }}</label>
          <input
            id="rpc-ship-addr2"
            class="v2-rpc-native-input"
            type="text"
            [placeholder]="'REQUEST_ADDRESS_2_PLACEHOLDER' | translate"
            [(ngModel)]="requestFormAddress2"
          />
        </div>

        <div class="v2-rpc-item v2-rpc-field">
          <label class="v2-rpc-field-label" for="rpc-ship-zip">{{
            'REQUEST_ZIPCODE_PLACEHOLDER_LABLE' | translate
          }}</label>
          <input
            id="rpc-ship-zip"
            class="v2-rpc-native-input"
            type="text"
            [placeholder]="'REQUEST_ZIPCODE_PLACEHOLDER' | translate"
            [(ngModel)]="requestFormZipcode"
          />
        </div>

        <div class="v2-rpc-item v2-rpc-field">
          <label class="v2-rpc-field-label" for="rpc-ship-locality">{{
            'REQUEST_LOCALITY_PLACEHOLDER_LABLE' | translate
          }}</label>
          <input
            id="rpc-ship-locality"
            class="v2-rpc-native-input"
            type="text"
            [placeholder]="'REQUEST_LOCALITY_PLACEHOLDER' | translate"
            [(ngModel)]="requestFormLocality"
          />
        </div>

        <div class="v2-rpc-item v2-rpc-field">
          <label class="v2-rpc-field-label" for="rpc-ship-phone">{{
            'REQUEST_TELEPHONE_PLACEHOLDER_LABLE' | translate
          }}</label>
          <input
            id="rpc-ship-phone"
            class="v2-rpc-native-input"
            type="tel"
            inputmode="tel"
            [placeholder]="'REQUEST_TELEPHONE_PLACEHOLDER' | translate"
            [(ngModel)]="requestFormTelephone"
          />
        </div>

        <div class="v2-rpc-section-divider" style="font-size: large; font-weight: bold">
          <div class="v2-rpc-lbl">{{'REQUEST_SHIP_TYPE'|translate}}</div>
        </div>

        <div class="v2-rpc-item">
          <div class="v2-rpc-radio-group" role="radiogroup">
            <label class="v2-rpc-radio-row">
              <input
                type="radio"
                name="rpc-nat-internat"
                value="pt"
                [(ngModel)]="requestFormNatInternat"
                (ngModelChange)="shipmentChanged()"
              />
              <span class="v2-rpc-radio-row__text"
                >{{'REQUEST_SHIP_TYPE_PT'|translate}}</span
              >
            </label>
            <label class="v2-rpc-radio-row">
              <input
                type="radio"
                name="rpc-nat-internat"
                value="ot"
                [(ngModel)]="requestFormNatInternat"
                (ngModelChange)="shipmentChanged()"
              />
              <span class="v2-rpc-radio-row__text"
                >{{'REQUEST_SHIP_TYPE_OT'|translate}}</span
              >
            </label>

            <div
              class="v2-rpc-item v2-rpc-field"
              *ngIf="requestFormNatInternat === 'ot'"
            >
              <label class="v2-rpc-field-label" for="rpc-ship-country">{{
                'REQUEST_COUNTRY_PLACEHOLDER_LABLE' | translate
              }}</label>
              <input
                id="rpc-ship-country"
                class="v2-rpc-native-input"
                type="text"
                [placeholder]="'REQUEST_COUNTRY_PLACEHOLDER'| translate"
                [(ngModel)]="requestFormCountry"
              />
            </div>
          </div>
        </div>

        <ng-container
          *ngIf="requestFormNatInternat === 'pt' || requestFormNatInternat === 'ot'"
        >
          <div
            class="v2-rpc-section-divider top-20"
            style="font-size: large; font-weight: bold"
          >
            <div class="v2-rpc-lbl">{{'SHIPPING_OPTIONS'| translate}}</div>
          </div>

          <div class="v2-rpc-item" *ngIf="shippingMethodsList.length === 0">
            <div class="v2-rpc-lbl v2-rpc-error-line">
              <span class="v2-rpc-alert-dot" aria-hidden="true"></span>
              {{'NO_SHIPPING_OPTIONS'| translate}}
            </div>
          </div>

          <div *ngIf="shippingMethodsList.length !== 0">
            <div class="v2-rpc-item">
              <div class="v2-rpc-radio-group" role="radiogroup">
                <label
                  class="v2-rpc-radio-row"
                  *ngFor="let item of shippingMethodsList"
                >
                  <input
                    type="radio"
                    name="rpc-shipping-option"
                    [value]="item.shipping_method_config_id"
                    [(ngModel)]="selectedMethodConfigId"
                    (ngModelChange)="onShippingOptionConfigChange($event)"
                  />
                  <span class="v2-rpc-radio-row__text"
                    ><b>{{item.name}}</b>
                    <p>{{item.description}}</p></span
                  >
                </label>
              </div>
            </div>
          </div>
        </ng-container>

        <div *ngIf="selectedMethod !== undefined">
          <div class="v2-rpc-section-divider" style="font-size: large; font-weight: bold">
            <div class="v2-rpc-lbl">{{'ORDER_DETAILS'|translate}}</div>
          </div>
          <div class="v2-rpc-item item-expand">
            <div class="item-inner item-inner--order-qty-row">
              <div class="item-input-wrapper v2-rpc-order-col v2-rpc-order-col--qty v2-rpc-qty-stepper-field">
                <div class="v2-rpc-field-label" id="rpc-album-qty-ship-label">{{ 'QUANTITY' | translate }}</div>
                <div
                  class="v2-rpc-qty-stepper"
                  role="group"
                  [attr.aria-labelledby]="'rpc-album-qty-ship-label'"
                >
                  <button
                    type="button"
                    class="v2-rpc-qty-stepper__btn"
                    (click)="decrementAlbumQty()"
                    [disabled]="isAlbumQtyDecrementDisabled()"
                    [attr.aria-label]="'DECREASE_QUANTITY' | translate"
                  >
                    −
                  </button>
                  <div class="v2-rpc-qty-stepper__value" aria-live="polite" aria-atomic="true">
                    {{ requestFormNumberOfUnits }}
                  </div>
                  <button
                    type="button"
                    class="v2-rpc-qty-stepper__btn"
                    (click)="incrementAlbumQty()"
                    [disabled]="isAlbumQtyIncrementDisabled()"
                    [attr.aria-label]="'INCREASE_QUANTITY' | translate"
                  >
                    +
                  </button>
                </div>
              </div>
              <div class="v2-rpc-order-col v2-rpc-order-col--unit-price v2-rpc-lbl" style="color: var(--ion-color-text)">
                <p>
                  {{'VALUE' | translate}} {{phyColVCents/100 |
                  currency:"EUR":"symbol"}} {{"VALUE_PER_ALBUM" | translate}}
                </p>
              </div>
            </div>
          </div>

          <div class="v2-rpc-section-divider" style="font-size: large; font-weight: bold">
            <div class="v2-rpc-lbl">{{'PHY_COL_VALUES'|translate}}</div>
          </div>
          <div class="v2-rpc-item v2-rpc-summary">
            <div class="v2-rpc-summary-lines">
              <div class="v2-rpc-summary-line">
                <span class="v2-rpc-summary-line__label">{{
                  'PHY_COL_COLLECTION_VAL' | translate
                }}</span>
                <span class="v2-rpc-summary-line__value">{{
                  getTotalCollectionPrice() | currency : 'EUR' : 'symbol'
                }}</span>
              </div>
              <div class="v2-rpc-summary-line">
                <span class="v2-rpc-summary-line__label">{{
                  'PHY_COL_COLLECTION_SHIPMENT' | translate
                }}</span>
                <span class="v2-rpc-summary-line__value">{{
                  getShippingPrice() | currency : 'EUR' : 'symbol'
                }}</span>
              </div>
            </div>
            <div class="v2-rpc-summary-total">
              <span class="v2-rpc-summary-total__label">{{
                'PHY_COL_COLLECTION_TOTAL' | translate
              }}</span>
              <span class="v2-rpc-summary-total__value">{{
                getTotalPrice() | currency : 'EUR' : 'symbol'
              }}</span>
            </div>
          </div>

          <div class="v2-rpc-section-divider" *ngIf="getTotalPrice()>0" style="font-size: large; font-weight: bold">
            <div class="v2-rpc-lbl">{{'FIN_METHODS'|translate}}</div>
          </div>

          <div class="v2-rpc-item" *ngIf="getTotalPrice()!=0">
            <div class="v2-rpc-row">
              <div class="v2-rpc-col">
                <div (click)="setFinMethod('MBWAY')">
                  <img
                    class="title-image"
                    [ngClass]="{'dimmed' : requestFormFinMethod!=='MBWAY'}"
                    src="/assets/images/mbway_logo.svg"
                    width="100%"
                    height="100%"
                    *ngIf="!body.classList.contains('dark')"
                  />
                  <img
                    class="title-image"
                    [ngClass]="{'dimmed' : requestFormFinMethod!=='MBWAY'}"
                    src="/assets/images/dark_mbway_logo.svg"
                    width="100%"
                    height="100%"
                    *ngIf="body.classList.contains('dark')"
                  />
                </div>
              </div>
              <div class="v2-rpc-col">
                <div (click)="setFinMethod('VISA')">
                  <img
                    class="title-image"
                    [ngClass]="{'dimmed' : requestFormFinMethod!=='VISA'}"
                    src="/assets/images/visa.svg"
                    width="100%"
                    height="100%"
                  />
                </div>
              </div>
              <div class="v2-rpc-col">
                <div (click)="setFinMethod('VISA')">
                  <img
                    class="title-image"
                    [ngClass]="{'dimmed' : requestFormFinMethod!=='VISA'}"
                    src="/assets/images/mastercard.svg"
                    width="100%"
                    height="100%"
                  />
                </div>
              </div>
              <div class="v2-rpc-col">
                <div (click)="setFinMethod('VISA')">
                  <img
                    class="title-image"
                    [ngClass]="{'dimmed' : requestFormFinMethod!=='VISA'}"
                    src="/assets/images/maestro.svg"
                    width="100%"
                    height="100%"
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            class="v2-rpc-item v2-rpc-mbway-block"
            *ngIf=" getTotalPrice()>0 && requestFormFinMethod==='MBWAY'"
          >
            <div class="v2-rpc-mbway-grid">
              <label class="v2-rpc-field-label v2-rpc-mbway-grid__label" for="rpc-mbway-ship">{{
                'GET_BINDERS_MBWAY_NUMBER' | translate
              }}</label>
              <input
                id="rpc-mbway-ship"
                #phoneInput
                class="v2-rpc-native-input v2-rpc-mbway-grid__input"
                inputmode="tel"
                type="tel"
                maxlength="9"
                [placeholder]="'REQUEST_PHONE_MBWAY_PLACEHOLDER' | translate"
                [attr.aria-invalid]="!validatePhonePT(requestFormMsisdn)"
                [(ngModel)]="requestFormMsisdn"
                (input)="appendCountryCode($event)"
              />
              <label class="v2-rpc-check-row v2-rpc-mbway-grid__save">
                <input type="checkbox" [(ngModel)]="requestFormStoreMsisdn" />
                <span>{{'GET_BINDERS_MBWAY_NUMBER_STORE' | translate}}</span>
              </label>
              <p
                class="v2-rpc-note error-message v2-rpc-mbway-grid__error"
                *ngIf="!validatePhonePT(requestFormMsisdn)"
                role="alert"
              >
                {{ 'INVALID_PT_PHONE' | translate }}
              </p>
            </div>
          </div>
          <div class="v2-rpc-item" *ngIf=" getTotalPrice()>0 && requestFormFinMethod==='VISA'">
            <div class="v2-rpc-row">
              <div class="v2-rpc-col v2-rpc-col--span-12">
                <p></p>
                <p style="text-align: center; font-size: small">
                  {{'TRANSLATE_VISA_FIN_EXPLAIN' | translate}}
                </p>
                <p></p>
              </div>
            </div>
          </div>

          <div class="v2-rpc-item" *ngIf="getTotalPrice()>0">
            <label class="v2-rpc-check-row">
              <input type="checkbox" [(ngModel)]="requestForminvoiceRequired" />
              <span>{{'GET_BINDERS_REQUIRE_INVOICE' | translate}}</span>
            </label>
          </div>

          <div class="v2-rpc-item" *ngIf="getTotalPrice()>0 && requestForminvoiceRequired">
            <div class="v2-rpc-row">
              <div class="v2-rpc-col">
                <input
                  class="v2-rpc-native-input"
                  inputmode="numeric"
                  type="text"
                  [(ngModel)]="requestFormNifForInvoice"
                  [placeholder]="'GET_BINDERS_PUT_NIF' | translate"
                  (ngModelChange)="onNifChange()"
                />
                <p
                  class="v2-rpc-note error-message"
                  *ngIf="!validNif"
                  >{{"INVALID_NIF"| translate}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="v2-rpc-submit-wrap">
      <app-btn
        class="v2-rpc-submit-end"
        [text]="'REQUEST_SHIP_TYPE_SUBMIT' | translate"
        [type]="validateForm() ? 'primary' : 'disabled'"
        (clicked)="submitRequest()"
      ></app-btn>
    </div>
    </div>
  </div>

  <div *ngIf="currentStatus==='PENDING_PAYMENT'">
    <!--ion-item class="ion-text-wrap ion-text-center"
      *ngIf="physCollectionIconPath === undefined || physCollectionIconPath === ''">
      <div class="col-div"><img class="col-icon" src="assets/images/logo-letter.svg"></div>
    </div>
    <div class="v2-rpc-item ion-text-wrap ion-text-center"
      *ngIf="physCollectionIconPath !== undefined && physCollectionIconPath !== ''">
      <div class="col-div"><img class="col-icon" src="{{physCollectionIconPath}}"></div>
    </div>
    <div class="v2-rpc-item">
      <div class="v2-rpc-lbl">
        <h2 class="ion-text-wrap ion-text-center">{{'PHYS_PENDING_PAYMENT' | translate}}</h2><br>
        <p class="ion-text-wrap ion-text-center">{{'PHYS_PENDING_PAYMENT_TEXT_1' | translate}}</p> <br>
        <p class="ion-text-wrap ion-text-center">{{'PHYS_PENDING_PAYMENT_TEXT_2' | translate}}</p> <br>
  <!       <p class="ion-text-wrap ion-text-center">{{'PHYS_PENDING_PAYMENT_TEXT_3' | translate}}</p> <br>
        <p class="ion-text-wrap ion-text-center">{{'PHYS_PENDING_PAYMENT_TEXT_4' | translate}}</p> <br> >
      </div>
    </ion-item-->
    <div class="loader-parent" style="z-index: 99">
      <div #lottiePendingPayment class="loader"></div>
      <h1
        class="loader-text-pending-payment"
        [class.loader-text-running]="loaderTextCssActive"
        (animationstart)="onLoaderTextAnimationStart($event)"
        (animationiteration)="onLoaderTextCycle($event)"
      >
        {{ animTexArr2[animTextNumber]|translate }}
      </h1>
    </div>
    <div class="v2-rpc-item">
      <div class="v2-rpc-row">
        <div class="v2-rpc-col">
          <app-btn
            class="v2-rpc-action-btn"
            type="primary"
            [text]="'CONTACT_US' | translate"
            (clicked)="contactRequest()"
          ></app-btn>
        </div>
      </div>
    </div>
    <div class="v2-rpc-item">
      <div class="v2-rpc-row">
        <div class="v2-rpc-col">
          <app-btn
            class="v2-rpc-action-btn"
            type="danger"
            [text]="'CANCEL_ORDER' | translate"
            (clicked)="cancelOrder()"
          ></app-btn>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="currentStatus==='WAITING_DISPATCH'">
    <div class="loader-parent" style="z-index: 99">
      <div #lottieWaitingDispatch class="loader"></div>
      <h1
        class="loader-text-Waiting-Dispatch"
        [class.loader-text-running]="loaderTextCssActive"
        (animationstart)="onLoaderTextAnimationStart($event)"
        (animationiteration)="onLoaderTextCycle($event)"
      >
        {{ animTexArr3[animTextNumber]|translate }}
      </h1>
    </div>
    <div class="v2-rpc-item">
      <div class="v2-rpc-row">
        <div class="v2-rpc-col">
          <app-btn
            class="v2-rpc-action-btn"
            type="primary"
            [text]="'CONTACT_US' | translate"
            (clicked)="contactRequest()"
          ></app-btn>
        </div>
      </div>
    </div>
    <div class="v2-rpc-item">
      <div class="v2-rpc-row">
        <div class="v2-rpc-col">
          <app-btn
            class="v2-rpc-action-btn"
            type="danger"
            [text]="'ADD_ENTRY_CANCEL' | translate"
            (clicked)="cancelRequest()"
          ></app-btn>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="currentStatus==='ON_HOLD'" class="display-code">
    <div *ngIf="code === ''">
      <!--ion-item class="ion-text-wrap ion-text-center"
        *ngIf="physCollectionIconPath === undefined || physCollectionIconPath === ''">
        <div class="col-div"><img class="col-icon" src="assets/images/logo-letter.svg"></div>
      </div>
      <div class="v2-rpc-item ion-text-wrap ion-text-center"
        *ngIf="physCollectionIconPath !== undefined && physCollectionIconPath !== '' && physCollectionIconPath !== 'empty'">
        <div class="col-div"><img class="col-icon" src="{{physCollectionIconPath}}"></div>
      </div>

      <div class="v2-rpc-item">
        <div class="v2-rpc-lbl">
          <h2 class="ion-text-wrap ion-text-center">{{'PHYS_ON_HOLD' | translate}}</h2><br>
          <p class="ion-text-wrap ion-text-center">{{'PHYS_ON_HOLD_TEXT_1' | translate}}</p> <br>
          <p class="ion-text-wrap ion-text-center">{{'PHYS_ON_HOLD_TEXT_2' | translate}}</p> <br>
          <p class="ion-text-wrap ion-text-center">{{'PHYS_ON_HOLD_TEXT_3' | translate}}</p> <br>
          <p class="ion-text-wrap ion-text-center">{{'PHYS_ON_HOLD_TEXT_4' | translate}}</p> <br>
        </div>
      </ion-item-->

      <div class="loader-parent" style="z-index: 99">
        <div #lottieOnHold class="loader"></div>
        <h1
          class="loader-text-OnHold"
          [class.loader-text-running]="loaderTextCssActive"
          (animationstart)="onLoaderTextAnimationStart($event)"
          (animationiteration)="onLoaderTextCycle($event)"
        >
          {{ animTexArr8[animTextNumber]|translate }}
        </h1>
      </div>

      <div class="v2-rpc-item">
        <div class="v2-rpc-row">
          <div class="v2-rpc-col">
            <app-btn
              class="v2-rpc-action-btn"
              type="primary"
              [text]="'BUTTON_GENERATE_CODE' | translate"
              (clicked)="generatePickUpCode()"
            ></app-btn>
          </div>
        </div>
      </div>
      <div class="v2-rpc-item">
        <div class="v2-rpc-row">
          <div class="v2-rpc-col">
            <app-btn
              class="v2-rpc-action-btn"
              type="danger"
              [text]="'ADD_ENTRY_CANCEL' | translate"
              (clicked)="cancelRequest()"
            ></app-btn>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="code !== ''">
      <div class="v2-rpc-grid v2-rpc-grid--fixed">
        <div class="v2-rpc-row">
          <div class="v2-rpc-col">
            <p class="v2-rpc-note">{{ 'PHY_COL_CODE_HELPER' | translate}}</p>
          </div>
        </div>

        <div class="v2-rpc-row">
          <div class="v2-rpc-col">
            <div class="v2-rpc-item ion-text-wrap ion-text-center"
              *ngIf="physCollectionIconPath === undefined || physCollectionIconPath === ''">
              <div class="col-div">
                <img
                  class="col-icon-large"
                  src="assets/images/logo-letter.svg"
                />
              </div>
            </div>
            <div class="v2-rpc-item ion-text-wrap ion-text-center"
              *ngIf="physCollectionIconPath !== undefined && physCollectionIconPath !== '' && physCollectionIconPath !== 'empty'">
              <div class="col-div">
                <img class="col-icon-large" src="{{physCollectionIconPath}}" />
              </div>
            </div>
            <div class="code">
              <p>
                {{code[0]}} {{code[1]}} {{code[2]}} {{code[3]}} {{code[4]}}
                {{code[5]}}
              </p>
            </div>
          </div>
        </div>

        <div class="v2-rpc-row">
          <div class="v2-rpc-col">
            <div class="counter">
              {{ counterMin | number: '2.0' }}:{{ counterSec | number: '2.0' }}
            </div>
          </div>
        </div>

        <div class="v2-rpc-row">
          <div class="v2-rpc-col">
            <p class="v2-rpc-note"> {{ 'PHY_COL_CODE_HELPER_2' | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="currentStatus==='READY' || currentStatus==='RECEIVED'">
    <!--ion-item class="ion-text-wrap ion-text-center"
      *ngIf="physCollectionIconPath === undefined || physCollectionIconPath === ''">
      <div class="col-div"><img class="col-icon" src="assets/images/logo-letter.svg"></div>
    </div>
    <div class="v2-rpc-item ion-text-wrap ion-text-center"
      *ngIf="physCollectionIconPath !== undefined && physCollectionIconPath !== ''">
      <div class="col-div"><img class="col-icon" src="{{physCollectionIconPath}}"></div>
    </div>

    <div class="v2-rpc-item">
      <div class="v2-rpc-lbl">
        <h2 class="ion-text-wrap ion-text-center">{{'PHYS_RECEIVED' | translate}}</h2><br>
        <p class="ion-text-wrap ion-text-center">{{'PHYS_RECEIVED_TEXT_1' | translate}}</p> <br>
        <p class="ion-text-wrap ion-text-center">{{'PHYS_RECEIVED_TEXT_2' | translate}}</p> <br>
        <p class="ion-text-wrap ion-text-center">{{'PHYS_RECEIVED_TEXT_3' | translate}}</p> <br>
        <<p class="ion-text-wrap ion-text-center">{{'PHYS_RECEIVED_TEXT_4' | translate}}</p> <br> >
      </div>
    </ion-item-->

    <div class="loader-parent" style="z-index: 99">
      <div #lottieReceived class="loader"></div>
      <h1
        class="loader-text-Received"
        [class.loader-text-running]="loaderTextCssActive"
        (animationstart)="onLoaderTextAnimationStart($event)"
        (animationiteration)="onLoaderTextCycle($event)"
      >
        {{ animTexArr5[animTextNumber]|translate }}
      </h1>
    </div>

    <div class="v2-rpc-item">
      <div class="v2-rpc-row">
        <div class="v2-rpc-col">
          <app-btn
            class="v2-rpc-action-btn"
            type="primary"
            [text]="'ADD_COLLECTION_PAGE_BTN' | translate"
            (clicked)="goToAddCol()"
          ></app-btn>
        </div>
      </div>
    </div>
    <div class="v2-rpc-item">
      <div class="v2-rpc-row">
        <div class="v2-rpc-col">
          <app-btn
            class="v2-rpc-action-btn"
            type="danger"
            [text]="'ADD_ENTRY_CANCEL' | translate"
            (clicked)="cancelRequest()"
          ></app-btn>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="currentStatus==='DISPATCHED'">
    <!--ion-item class="ion-text-wrap ion-text-center"
      *ngIf="physCollectionIconPath === undefined || physCollectionIconPath === ''">
      <div class="col-div"><img class="col-icon" src="assets/images/logo-letter.svg"></div>
    </div>
    <div class="v2-rpc-item ion-text-wrap ion-text-center"
      *ngIf="physCollectionIconPath !== undefined && physCollectionIconPath !== ''">
      <div class="col-div"><img class="col-icon" src="{{physCollectionIconPath}}"></div>
    </div>

    <div class="v2-rpc-item">
      <div class="v2-rpc-lbl">
        <h2 class="ion-text-wrap ion-text-center">{{'PHYS_DISPATCHED' | translate}}</h2><br>
        <p class="ion-text-wrap ion-text-center">{{'PHYS_DISPATCHED_TEXT_1' | translate}}</p> <br>
        <p class="ion-text-wrap ion-text-center">{{'PHYS_DISPATCHED_TEXT_2' | translate}}</p> <br>
        <       <p class="ion-text-wrap ion-text-center">{{'PHYS_DISPATCHED_TEXT_3' | translate}}</p> <br>
        <p class="ion-text-wrap ion-text-center">{{'PHYS_DISPATCHED_TEXT_4' | translate}}</p> <br> >
      </div>
    </ion-item-->

    <div class="loader-parent" style="z-index: 99">
      <div #lottieDispatched class="loader"></div>
      <h1
        class="loader-text-Dispatched"
        [class.loader-text-running]="loaderTextCssActive"
        (animationstart)="onLoaderTextAnimationStart($event)"
        (animationiteration)="onLoaderTextCycle($event)"
      >
        {{ animTexArr4[animTextNumber]|translate }}
      </h1>
    </div>

    <div class="v2-rpc-item">
      <div class="v2-rpc-row">
        <div class="v2-rpc-col">
          <app-btn
            class="v2-rpc-action-btn"
            type="primary"
            [text]="'PHYS_RECEIVED_BTN' | translate"
            (clicked)="receivedRequest()"
          ></app-btn>
        </div>
      </div>
    </div>
    <div class="v2-rpc-item">
      <div class="v2-rpc-row">
        <div class="v2-rpc-col">
          <app-btn
            class="v2-rpc-action-btn"
            type="primary"
            [text]="'CONTACT_US' | translate"
            (clicked)="reportRequest()"
          ></app-btn>
        </div>
      </div>
    </div>
    <div class="v2-rpc-item">
      <div class="v2-rpc-row">
        <div class="v2-rpc-col">
          <app-btn
            class="v2-rpc-action-btn"
            type="danger"
            [text]="'ADD_ENTRY_CANCEL' | translate"
            (clicked)="cancelRequest()"
          ></app-btn>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="currentStatus==='DIDNT_RECEIVE'">
    <!--ion-item class="ion-text-wrap ion-text-center"
      *ngIf="physCollectionIconPath === undefined || physCollectionIconPath === ''">
      <div class="col-div"><img class="col-icon" src="assets/images/logo-letter.svg"></div>
    </div>
    <div class="v2-rpc-item ion-text-wrap ion-text-center"
      *ngIf="physCollectionIconPath !== undefined && physCollectionIconPath !== ''">
      <div class="col-div"><img class="col-icon" src="{{physCollectionIconPath}}"></div>
    </div>
    <div class="v2-rpc-item">
      <div class="v2-rpc-lbl">
        <h2 class="ion-text-wrap ion-text-center">{{'PHYS_DIDNT_RECEIVE' | translate}}</h2><br>
        <p class="ion-text-wrap ion-text-center">{{'PHYS_DIDNT_RECEIVE_TEXT_1' | translate}}</p> <br>
        <p class="ion-text-wrap ion-text-center">{{'PHYS_DIDNT_RECEIVE_TEXT_2' | translate}}</p> <br>
        <<p class="ion-text-wrap ion-text-center">{{'PHYS_DIDNT_RECEIVE_TEXT_3' | translate}}</p> <br>
        <p class="ion-text-wrap ion-text-center">{{'PHYS_DIDNT_RECEIVE_TEXT_4' | translate}}</p> <br> >
      </div>
    </ion-item-->

    <!--   <div class="v2-rpc-item">
      <p class="ion-text-wrap ion-text-center">{{'PHYS_DIDNT_RECEIVE_TEXT_3' | translate}}</p> <br>
      <textarea class="v2-rpc-native-textarea" rows="3" readonly disabled></textarea>

    </div> -->

    <div class="loader-parent" style="z-index: 99">
      <div #lottieDidntReceive class="loader"></div>
      <h1
        class="loader-text-Didnt-Receive"
        [class.loader-text-running]="loaderTextCssActive"
        (animationstart)="onLoaderTextAnimationStart($event)"
        (animationiteration)="onLoaderTextCycle($event)"
      >
        {{ animTexArr9[animTextNumber]|translate }}
      </h1>
    </div>

    <div class="v2-rpc-item">
      <div class="v2-rpc-row">
        <div class="v2-rpc-col">
          <app-btn
            class="v2-rpc-action-btn"
            type="primary"
            [text]="'PHYS_RECEIVED_BTN' | translate"
            (clicked)="receivedRequest()"
          ></app-btn>
        </div>
      </div>
    </div>
    <div class="v2-rpc-item">
      <div class="v2-rpc-row">
        <div class="v2-rpc-col">
          <app-btn
            class="v2-rpc-action-btn"
            type="primary"
            [text]="'CONTACT_US' | translate"
            (clicked)="contactRequest()"
          ></app-btn>
        </div>
      </div>
    </div>
    <div class="v2-rpc-item">
      <div class="v2-rpc-row">
        <div class="v2-rpc-col">
          <app-btn
            class="v2-rpc-action-btn"
            type="danger"
            [text]="'ADD_ENTRY_CANCEL' | translate"
            (clicked)="cancelRequest()"
          ></app-btn>
        </div>
      </div>
    </div>

    <style scoped>
      .button-container {
        display: flex;
        justify-content: center;
        margin-top: 20px;
      }
    </style>
  </div>

  <div *ngIf="currentStatus==='CANCELLED'">
    <!--ion-item class="ion-text-wrap ion-text-center"
      *ngIf="physCollectionIconPath === undefined || physCollectionIconPath === ''">
      <div class="col-div"><img class="col-icon" src="assets/images/logo-letter.svg"></div>
    </div>
    <div class="v2-rpc-item ion-text-wrap ion-text-center"
      *ngIf="physCollectionIconPath !== undefined && physCollectionIconPath !== ''">
      <div class="col-div"><img class="col-icon" src="{{physCollectionIconPath}}"></div>
    </div>
    <div class="v2-rpc-item">
      <div class="v2-rpc-lbl">
        <h2 class="ion-text-wrap ion-text-center">{{'PHYS_CANCELLED' | translate}}</h2><br>
        <p class="ion-text-wrap ion-text-center">{{'PHYS_CANCELLED_TEXT_1' | translate}}</p> <br>
        <p class="ion-text-wrap ion-text-center">{{'PHYS_CANCELLED_TEXT_2' | translate}}</p> <br>
        <  <p class="ion-text-wrap ion-text-center">{{'PHYS_CANCELLED_TEXT_3' | translate}}</p> <br>>
        <  <p class="ion-text-wrap ion-text-center">{{'PHYS_CANCELLED_TEXT_4' | translate}}</p> <br> >
      </div>
    </ion-item-->

    <div class="loader-parent" style="z-index: 99">
      <div #lottieCancelled class="loader"></div>
      <h1
        class="loader-text-Cancelled"
        [class.loader-text-running]="loaderTextCssActive"
        (animationstart)="onLoaderTextAnimationStart($event)"
        (animationiteration)="onLoaderTextCycle($event)"
      >
        {{ animTexArr7[animTextNumber]|translate }}
      </h1>
    </div>

    <div class="v2-rpc-item">
      <div class="v2-rpc-row">
        <div class="v2-rpc-col">
          <app-btn
            class="v2-rpc-action-btn"
            type="primary"
            [text]="'CONTACT_US' | translate"
            (clicked)="contactRequest()"
          ></app-btn>
        </div>
      </div>
    </div>
    <div class="v2-rpc-item">
      <div class="v2-rpc-row">
        <div class="v2-rpc-col">
          <app-btn
            class="v2-rpc-action-btn"
            type="danger"
            [text]="'ADD_ENTRY_CANCEL' | translate"
            (clicked)="cancelRequest()"
          ></app-btn>
        </div>
      </div>
    </div>
  </div>
        </main>
      </div>
    </div>
  </div>
</div>
